import { productAnalytics } from '@/libs/product-analytics';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet, useLocation, useMatch } from 'react-router-dom';
import { useProductAnalytics } from './ProductAnalyticsProvider';
import { AnalyticsPreferencesControl } from './AnalyticsPreferences';

export function ProductAnalyticsRouteTracker() {
  const { pathname } = useLocation();
  const isLogin = useMatch('/');
  const isSignup = useMatch('/signup');
  const isPreferences = useMatch('/settings/account/preferences');
  const { enabled } = useProductAnalytics();
  const { i18n } = useTranslation();
  const language = i18n.language.startsWith('fr') ? 'fr' : 'en';
  useEffect(() => {
    if (enabled)
      productAnalytics.screen(pathname, {
        language,
        browser_mode: window.matchMedia?.('(display-mode: standalone)').matches
          ? 'standalone'
          : 'browser',
      });
  }, [pathname, enabled, language]);
  return (
    <>
      <Outlet />
      {!isLogin && !isSignup && !isPreferences ? <AnalyticsPreferencesControl /> : null}
    </>
  );
}
